import React, { useState } from "react";
// import apiClient from '../utils/apiClient.js';
import apiClient from '../../utils/apiClient.js';

const AddAttemptForm = ({ servee, location, onSubmit, onCancel, isLoading }) => {
    const [note, setNote] = useState('');
    const [file, setFile] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!note.trim() && !file) {
            alert("Please add an attempt note or select a file.");
            return;
        }

        const payload = {
            servee_id: servee.id,
            attempt_note: note, 
            latitude: location.lat,
            longitude: location.lng,
            service_date: new Date().toISOString().split('T')[0],
            service_time: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
            am_pm: new Date().getHours() >= 12 ? 'PM' : 'AM',
        };

        // ✅ ADD THIS LINE HERE: Trigger the Checklist!
        apiClient.post('/onboarding/events', { event_name: 'first_activity_logged' }).catch(() => {});


        onSubmit(payload, file);
    };

    return (
        <div className="p-4 border border-yellow-300 rounded-md bg-yellow-50">
            <h4 className="font-bold text-yellow-700">Record Attempt for {servee.full_name}</h4>
            <form onSubmit={handleSubmit} className="mt-2 space-y-3">
                <textarea
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    rows="2"
                    placeholder="Enter detailed attempt note..."
                    className="w-full border p-2 text-sm rounded-md"
                />
                <input type="file" onChange={(e) => setFile(e.target.files[0])} className="text-sm" />
                <div className="flex space-x-2">
                    <button type="submit" disabled={isLoading} className="btn-action bg-yellow-600 text-white">
                        {isLoading ? 'Recording...' : 'Record Attempt'}
                    </button>
                    <button type="button" onClick={onCancel} className="btn-action bg-gray-400 text-white">Cancel</button>
                </div>
            </form>
        </div>
    );
};

export default AddAttemptForm;  